/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAdultChildFill = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M6 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0zm1-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM4 14v2h2v4h2v-4h2v-2a3 3 0 1 0-6 0zm8 4h-2v4H4v-4H2v-4a5 5 0 0 1 10 0v4zm3-9a3 3 0 1 1 6 0 3 3 0 0 1-6 0zm6 10h1v-2a4 4 0 1 0-8 0v2h1v3h6v-3z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgAdultChildFill as AdultChildFill };
